import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Page404Component } from './authentication/page404/page404.component';
import { AuthGuard } from './core/guard/auth.guard';
import { SchoolResolver } from './core/resolvers/school.resolver';
import { AuthLayoutComponent } from './layout/app-layout/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './layout/app-layout/main-layout/main-layout.component';
import { ReportLayoutComponent } from './layout/app-layout/report-layout/report-layout.component';

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    resolve: {
      schools: SchoolResolver,
    },
    // canActivate: [AuthGuard],
    children: [
      {
        path: '', redirectTo: '/authentication/signin', pathMatch: 'full', resolve: {
          schools: SchoolResolver,
        }
      },
      {
        path: 'page',
        loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), resolve: {
          // schools: SchoolResolver,
        },
      }
    ]
  },
  {
    path: 'authentication',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      )
  },

  {
    path: 'report',
    component: ReportLayoutComponent,
    loadChildren: () =>
      import('./report/report.module').then(
        (m) => m.ReportModule
      )
  },
  { path: '**', component: Page404Component }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'legacy'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
